import React, { useEffect } from 'react'
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, UncontrolledTooltip, Card
} from 'reactstrap'
import _ from 'lodash'
import ReactTable from 'react-table'

import PageTitle from 'components/PageTitle'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import DeleteConfirmation from 'components/Modal/delete'
import Lang from 'Lang/General'

import TypesSettingForm from './Form'
import WithTypesSettingsHOC from './actions.js'

const TypesSettings = props => {
  useEffect( () => {
    props.getTypesSettings()
  }, [] )

  useEffect( () => {
    if( !props.showCreateTypesSetting ){
      props.onChangeTypesSettingsHOC( 
        'newTypesSetting', 
        { name: { en: '', de: '', it: '', nl: '' } } 
      )
    }
  }, [ props.showCreateTypesSetting ] )

  useEffect( () => {
    if( !props.showUpdateTypesSetting ){
      props.onChangeTypesSettingsHOC( 'selectedTypesSetting', {} )
    }
  }, [ props.showUpdateTypesSetting ] )

  const handleSecurityModulesCreate = () => {
    let tmp = _.find( props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Member Area' })
      return tmpModules.is_create
    }
  }

  const handleSecurityModulesUpdate = () => {
    let tmp = _.find( props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Member Area' })
      return tmpModules.is_update
    }
  }

  const handleSecurityModulesDelete= () => {
    let tmp = _.find( props.data.roleReducer.role.platforms, { name: 'Ark Management' })
    let tmpModules = {}
    if ( tmp ){
      tmpModules = _.find( tmp.modules, { name: 'Member Area' })
      return tmpModules.is_delete
    }
  }

  const renderCreateTypesSettingModal = () => (
    <Modal size='md' isOpen={ props.showCreateTypesSetting } >
      <ModalHeader toggle={ () => props.onChangeTypesSettingsHOC( 'showCreateTypesSetting', false ) } >
        { Lang[ 'CREATE' ][ props.data.languageReducer.lang ] }
      </ModalHeader>
      <ModalBody>
        <TypesSettingForm
          typesSettingType='newTypesSetting'
          currentTypesSetting={ props.newTypesSetting }
          onChangeTypesSettingsHOC={ props.onChangeTypesSettingsHOC }
          lang={ props.data.languageReducer.lang }
        />
        { props.onLoadTypesSettingsHOC && <LoadingOverlay/> }
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={ () => props.createTypesSetting( props.newTypesSetting ) }>
          { Lang[ 'SUBMIT' ][ props.data.languageReducer.lang ] }</Button>
      </ModalFooter>
    </Modal>
  )

  const renderUpdateTypesSettingModal = () => (
    <Modal size='md' isOpen={ props.showUpdateTypesSetting } >
      <ModalHeader toggle={ () => props.onChangeTypesSettingsHOC( 'showUpdateTypesSetting', false ) } >
        { Lang[ 'UPDATE' ][ props.data.languageReducer.lang ] }
      </ModalHeader>
      <ModalBody>
        <TypesSettingForm
          typesSettingType='selectedTypesSetting'
          currentTypesSetting={ props.selectedTypesSetting }
          onChangeTypesSettingsHOC={ props.onChangeTypesSettingsHOC }
          lang={ props.data.languageReducer.lang }
        />
        { props.onLoadTypesSettingsHOC && <LoadingOverlay/> }
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={ () => props.updateTypesSetting( props.selectedTypesSetting ) }>
          { Lang[ 'SUBMIT' ][ props.data.languageReducer.lang ] }</Button>
      </ModalFooter>
    </Modal>
  )

  return(
    <>
      <PageTitle
        heading={ Lang[ 'EVENT_TYPES' ][ props.data.languageReducer.lang ] }
        icon="pe-7s-users icon-gradient bg-happy-fisher"
        buttons={[
          {
            buttonText: Lang[ 'CREATE' ][ props.data.languageReducer.lang ],
            onClick: () => props.onChangeTypesSettingsHOC( 'showCreateTypesSetting', true ),
            display: handleSecurityModulesCreate()
          }
        ]}/>
      <Card className='p-4'>
        <ReactTable
          showPagination
          pageSize={ 10 }
          data={ props.typesSettings }
          columns={[
            {
              Header: Lang[ 'NAME' ][ props.data.languageReducer.lang ],
              accessor: "name",
              Cell: ({ value }) => value[ props.data.languageReducer.lang ] 
            },
            {
              Header: Lang[ 'ACTIONS' ][ props.data.languageReducer.lang ],
              accessor: "id",
              Cell: ({ value }) => (
                <div className='d-flex w-100 justify-content-center' >
                  {
                    handleSecurityModulesUpdate() && (
                      <>
                        <Button
                          id={ `TypesSetting-${ value }-update` }
                          className="mb-2 mr-2 btn-icon btn-icon-only"
                          color="primary"
                          onClick={ () => props.getSelectedTypesSetting( value ) }>
                          <i className="pe-7s-note"> </i>
                        </Button>
                        <UncontrolledTooltip
                          target={ `TypesSetting-${ value }-update` }
                          placement="top">{ Lang[ 'EDIT' ][ props.data.languageReducer.lang ] }</UncontrolledTooltip>
                      </>
                    )
                  }
                  {
                    handleSecurityModulesDelete() && (
                      <>
                        <Button
                          id={ `TypesSetting-${ value }-archive-typesSetting` }
                          className="mb-2 mr-2 btn-icon btn-icon-only"
                          color="danger"
                          onClick={ () => props.onChangeTypesSettingsHOC( 'showDeleteTypesSettingId', parseInt( value ) ) }>
                          <i className="pe-7s-trash"> </i>
                        </Button>
                        <UncontrolledTooltip
                          target={ `TypesSetting-${ value }-archive-typesSetting` }
                          placement="top">{ Lang[ 'REMOVE' ][ props.data.languageReducer.lang ] }</UncontrolledTooltip>
                      </>
                    )
                  }
                </div>
              )
            }
          ]}
        />
      </Card>
      <DeleteConfirmation
        handleModalClose={ () => props.onChangeTypesSettingsHOC( 'showDeleteTypesSettingId', 0 ) }
        deleteOpen={ props.showDeleteTypesSettingId > 0 }
        confirmAction={ () => props.removeTypesSetting( props.showDeleteTypesSettingId ) }
        content={ Lang[ 'DELETE_CONFIRMATION_EVENT_TYPE' ][ props.data.languageReducer.lang ] }
        lang={ props.data.languageReducer.lang } />
      { renderCreateTypesSettingModal() }
      { renderUpdateTypesSettingModal() }
      { props.onLoadTypesSettingsHOC && <LoadingOverlay/> }
    </>
  )
}

export default WithTypesSettingsHOC( TypesSettings )